import { useEffect } from 'react';

// Документ, який можна переглянути й надрукувати в браузері: .docx, що
// лежить у нашому сховищі (документи з шаблонів, 24.10). Файли, завантажені
// вручну раніше, — лише «Завантажити».
export const isPreviewableDocx = (doc) => !!doc?.file?.storagePath
  && (/wordprocessingml/.test(doc.file.type || '') || /\.docx$/i.test(doc.file.name || ''));

/**
 * Escape закриває лише верхнє вікно. Картка клієнта слухає Escape на
 * document — ловимо раніше (фаза захоплення на window) і далі не пускаємо.
 */
export function useCloseOnEscape(onClose) {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key !== 'Escape') return;
      e.stopPropagation();
      onClose();
    };
    window.addEventListener('keydown', onKey, true);
    return () => window.removeEventListener('keydown', onKey, true);
  }, [onClose]);
}
